export const mobileTabs = [
  { path: '/portal/workbench', label: '工作台', icon: 'workbench', disabled: false },
  { path: '/portal/todos', label: '任务', icon: 'tasks', disabled: false },
  { path: '/portal/notifications', label: '通知', icon: 'notices', disabled: true },
  { path: '/portal/personal', label: '我的', icon: 'me', disabled: true }
] as const;

export type MobileTabPath = (typeof mobileTabs)[number]['path'];

export type MobileRoute =
  | { kind: 'workbench' }
  | { kind: 'tasks' }
  | { kind: 'drafts' }
  | { kind: 'task-detail'; taskId: string }
  | { kind: 'notifications' }
  | { kind: 'apps' }
  | { kind: 'me' }
  | { kind: 'business'; appCode: string; sectionCode: string };

export function routeFromPath(pathname: string): MobileRoute {
  const path = pathname.replace(/\/$/, '') || '/portal/workbench';
  if (path === '/portal/todos') return { kind: 'tasks' };
  if (path === '/portal/drafts') return { kind: 'drafts' };
  if (/^\/portal\/todos\/[^/]+\/[^/]+$/.test(path)) return { kind: 'task-detail', taskId: path.split('/').at(-1)! };
  if (path.startsWith('/portal/todos/')) return { kind: 'tasks' };
  if (path === '/portal/notifications') return { kind: 'notifications' };
  if (path === '/portal/operations' || path.startsWith('/portal/operations/')) return { kind: 'apps' };
  if (!path.startsWith('/portal/')) {
    const [, , , appCode = '', sectionCode = ''] = path.split('/');
    return { kind: 'business', appCode, sectionCode };
  }
  if (path === '/portal/personal') return { kind: 'me' };
  return { kind: 'workbench' };
}

export function tabForRoute(route: MobileRoute): MobileTabPath | null {
  if (route.kind === 'business') return null;
  if (route.kind === 'tasks' || route.kind === 'drafts' || route.kind === 'task-detail') return '/portal/todos';
  if (route.kind === 'notifications') return '/portal/notifications';
  if (route.kind === 'me') return '/portal/personal';
  return '/portal/workbench';
}
